export function fadeInBlocks() {
    const elements = document.querySelectorAll('.block:not(:first-of-type');

    elements.forEach((el) => {
        gsap.fromTo(
        el,
        {
            autoAlpha: 0,
            y: 80
        },
        {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none none',
            once: true
            }
        }
        );
    });
}
